import React, { memo, ChangeEvent } from 'react';

import { useTranslation } from 'Shared/utils/hooks/use-translation';

import { useDeepEqualSelector } from 'Shared/utils/hooks';
import TextField from 'Shared/components/TextField/TextField';
import { getRecurringMeetingWithoutWorkspaces } from 'Shared/selectors/user';
import ConnectedCalendarIcon from 'Shared/components/ConnectedCalendarIcon/ConnectedCalendarIcon';

import WorkspaceNameSuggestions from './WorkspaceNameSuggestions/WorkspaceNameSuggestions';

import './GroupWorkspaceNameInput.scss';

type Props = {
  isSuggestionOpened: boolean;
  recurringMeetingId: number;
  workspaceName: string;
  onWorkspaceNameSet: Function;
  onWorkspaceNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onInviteesChange: Function;
  onSetRecurringMeetingId: Function;
  onSetIsSuggestionOpened: Function;
};

function GroupWorkspaceNameInput({
  isSuggestionOpened,
  recurringMeetingId,
  workspaceName,
  onWorkspaceNameSet,
  onWorkspaceNameChange,
  onInviteesChange,
  onSetRecurringMeetingId,
  onSetIsSuggestionOpened,
}: Props) {
  const { tr } = useTranslation();

  const recurringMeetings = useDeepEqualSelector(getRecurringMeetingWithoutWorkspaces());

  const handleWorkspaceNameChange = event => {
    onSetIsSuggestionOpened(true);
    onWorkspaceNameChange(event);
  };

  const handleSuggestionClick = ({ name, emails, recurringMeetingId: recurringMeetingIdParam }) => {
    onSetIsSuggestionOpened(false);
    onWorkspaceNameSet(name);
    onInviteesChange(emails);
    onSetRecurringMeetingId(recurringMeetingIdParam);
  };

  const handleTextInputFocus = () => onSetIsSuggestionOpened(true);

  const handleTextInputBlur = () => setTimeout(() => onSetIsSuggestionOpened(false), 500);

  return (
    <div className="group-workspace-name-input d-flex flex-column mt-3">
      <div className="position-relative">
        <TextField
          type="text"
          label={tr('perform.workspace.add_group_modal.group_name_label')}
          labelMuted={false}
          wrapperClassName="mt-3 pb-3"
          placeholder={tr('perform.workspace.add_group_modal.group_name_placeholder')}
          value={workspaceName}
          inputIcon={recurringMeetingId && <ConnectedCalendarIcon />}
          onFocus={handleTextInputFocus}
          onBlur={handleTextInputBlur}
          onChange={handleWorkspaceNameChange}
        />
      </div>
      <WorkspaceNameSuggestions
        isSuggestionOpened={isSuggestionOpened}
        workspaceName={workspaceName}
        recurringMeetings={Array.isArray(recurringMeetings) ? recurringMeetings : []}
        onSuggestionClick={handleSuggestionClick}
      />
    </div>
  );
}

export default memo(GroupWorkspaceNameInput);
